export default "__VITE_ASSET__CetLL5DR__"